import { render } from "./home.vue?vue&type=template&id=04a45fea"
const script = {}
script.render = render

export default script